export const FileStatus = {
  missing: 'missing',
  rejected: 'rejected',
  valid: 'valid',
  waiting: 'waiting'
};
